export { NileGridHeadItem } from './nile-grid-head-item';